import { z } from 'zod';
import { CUESTIONARIO_D28, CUESTIONARIO_D120, CUESTIONARIO_D180, CUESTIONARIO_D240, CUESTIONARIO_D300, CUESTIONARIO_D360, MEDICACION_AL_EGRESO, } from '../cuestionarios/hitos.js';
import { FORMULARIO_CAS_E } from './cas-e.js';
import { FORMULARIO_EQ5D5L } from './eq5d5l.js';
import { FORMULARIO_KATZ15 } from './katz15.js';
import { FORMULARIO_MICROCHECK, FORMULARIO_MICROCHECK_MENSUAL, FORMULARIO_MICROCHECK_MENSUAL_AMPLIADO, } from './microcheck.js';
import { FORMULARIO_NMS } from './nms.js';
/**
 * Catálogo cerrado de formularios administrables.
 *
 * Mismo criterio que el catálogo de eventos: la lista es cerrada y el `id` es
 * lo único que la API acepta del cliente. Un formulario que no está acá no se
 * puede abrir, así que no hay forma de que un cliente pida administrar algo que
 * nadie definió.
 *
 * El `id` coincide con el `id` del `Questionnaire` en el FHIR store. No es
 * casualidad ni comodidad: es lo que hace que un `QuestionnaireResponse` se
 * pueda leer contra su definición sin una tabla de traducción en el medio.
 */
const FORMULARIOS = [
    FORMULARIO_NMS,
    FORMULARIO_CAS_E,
    FORMULARIO_KATZ15,
    FORMULARIO_EQ5D5L,
    FORMULARIO_MICROCHECK,
    FORMULARIO_MICROCHECK_MENSUAL,
    FORMULARIO_MICROCHECK_MENSUAL_AMPLIADO,
    // Los cuestionarios de hito y la medicación al egreso (E3.25, D-01).
    CUESTIONARIO_D28,
    CUESTIONARIO_D120,
    CUESTIONARIO_D180,
    CUESTIONARIO_D240,
    CUESTIONARIO_D300,
    CUESTIONARIO_D360,
    MEDICACION_AL_EGRESO,
];
export const CATALOGO_DE_FORMULARIOS = Object.freeze(Object.fromEntries(FORMULARIOS.map((formulario) => [formulario.id, formulario])));
export const IDS_DE_FORMULARIO = FORMULARIOS.map((formulario) => formulario.id);
export const idDeFormularioSchema = z.string().refine((id) => id in CATALOGO_DE_FORMULARIOS, {
    message: `el formulario tiene que ser uno de: ${IDS_DE_FORMULARIO.join(', ')}`,
});
export function esIdDeFormulario(id) {
    return id in CATALOGO_DE_FORMULARIOS;
}
/** El formulario, o un error de programación si el id no está en el catálogo. */
export function formularioPorId(id) {
    const formulario = CATALOGO_DE_FORMULARIOS[id];
    if (!formulario) {
        throw new Error(`El formulario "${id}" está fuera del catálogo. ` +
            `Los definidos son: ${IDS_DE_FORMULARIO.join(', ')}.`);
    }
    return formulario;
}
/** El formulario de una escala, por instrumento. */
export function formularioDelInstrumento(instrumento) {
    const formulario = FORMULARIOS.find((candidato) => candidato.instrumento === instrumento);
    if (!formulario)
        throw new Error(`Sin formulario para el instrumento ${instrumento}`);
    return formulario;
}
//# sourceMappingURL=catalogo.js.map